import { render, staticRenderFns } from "./environmentDetection.vue?vue&type=template&id=dfde9a82&scoped=true"
import script from "./environmentDetection.vue?vue&type=script&lang=js"
export * from "./environmentDetection.vue?vue&type=script&lang=js"
import style0 from "./environmentDetection.vue?vue&type=style&index=0&id=dfde9a82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfde9a82",
  null
  
)

export default component.exports